import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { ReservationModel } from 'src/app/models/ReservationModel';
import { ReservationService } from 'src/app/services/ReservationService';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';

@Component({
  selector: 'app-booking-search',
  templateUrl: './booking-search.component.html',
  styleUrls: ['./booking-search.component.css']
})
export class BookingSearchComponent implements OnInit {
  patientCode ='';
  patientName = '';
  resDate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  resDate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  resDuration = '';
  resRoom = '';
  resRoomDesc = '';
  resDoc = '';
  resDocName = '';
  resType = '';
  resNotes = '';
  resStatus = '';
  resPhone ='';
  userID = '';
  modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  compCode = '1';
  ResrvationList: ReservationModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();                    ///----------- for searching pop up -----------

  constructor(public dialogRef: MatDialogRef<BookingSearchComponent>,
              public reservationservice : ReservationService,
              public reservaition : ReservationModel,
              public doctorservice : DoctorsService,
              public dataBankService : DataBankService,
              public doctors : DoctorsModel,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.resDate = data.resdate
  }

  ngOnInit(): void {
    this.retriveDoctorsLookupTop();
  }
  retriveDoctorsLookupTop() {
    this.ResrvationList = [];
    this.reservationservice.getReservationDate(this.resDate,this.compCode).subscribe((data: ReservationModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ResrvationList[i] = data[i];
        this.doctorservice.getdoctors(this.ResrvationList[i].resDoc,this.compCode).subscribe((data: DoctorsModel) => {
          this.ResrvationList[i].resDocName = data.docName;
      })

     
      }

    })
  }

  retriveResLookup(){}
  SelectDoctors(Do : ReservationModel){
    this.reservaition.patientCode = Do.patientCode
    this.reservaition.patientName = Do.patientName

    this.submitClicked.emit(this.reservaition);
    this.dialogRef.close();
  }
}
